var check = require('../util/regex-check');
module.exports = check(/[!-/:-@[-`{-~]/);